// extracted by mini-css-extract-plugin
export default {"root":"IconTooltip_root__SyB+T","tooltip":"IconTooltip_tooltip__Yx4eY","show":"IconTooltip_show__s5Bz9","arrow":"IconTooltip_arrow__o5aQL","tail":"IconTooltip_tail__8E3t2"};